/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const ConditionsIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#096DD9',
  width = 24,
  height = 28,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5 22.75C24.5 24.6805 22.9305 26.25 21 26.25C19.0695 26.25 17.5 24.6805 17.5 22.75C17.5 21.1422 18.5938 19.7859 20.0703 19.3758C19.6437 16.4445 16.7398 14.875 14 14.875C11.2602 14.875 8.35078 16.4445 7.92969 19.3758C9.41172 19.7859 10.5 21.1422 10.5 22.75C10.5 24.6805 8.93047 26.25 7 26.25C5.06953 26.25 3.5 24.6805 3.5 22.75C3.5 21.1094 4.6375 19.7258 6.16328 19.3539C6.35469 17.5328 7.24609 15.9852 8.75547 14.8367C9.96953 13.918 11.5227 13.3328 13.1195 13.1742V8.64062C11.6102 8.25234 10.4945 6.87969 10.4945 5.25C10.4945 3.31953 12.0641 1.75 13.9945 1.75C15.925 1.75 17.4945 3.31953 17.4945 5.25C17.4945 6.87969 16.3789 8.25234 14.8695 8.64062V13.1687C16.4664 13.3273 18.025 13.9125 19.2336 14.8313C20.7484 15.9797 21.6344 17.5273 21.8258 19.3484C23.3625 19.7258 24.5 21.1094 24.5 22.75ZM5.25 22.75C5.25 23.7125 6.0375 24.5 7 24.5C7.9625 24.5 8.75 23.7125 8.75 22.75C8.75 21.7875 7.9625 21 7 21C6.0375 21 5.25 21.7875 5.25 22.75ZM15.75 5.25C15.75 4.2875 14.9625 3.5 14 3.5C13.0375 3.5 12.25 4.2875 12.25 5.25C12.25 6.2125 13.0375 7 14 7C14.9625 7 15.75 6.2125 15.75 5.25ZM21 21C20.0375 21 19.25 21.7875 19.25 22.75C19.25 23.7125 20.0375 24.5 21 24.5C21.9625 24.5 22.75 23.7125 22.75 22.75C22.75 21.7875 21.9625 21 21 21Z"
        fill={color}
      />
    </svg>
  );
};
